const Loader = () => {
  return (
    <div className="position-fixed top-50 start-50 translate-middle loader">
      <div className="spinner-border text-primary" role="status"></div>
    </div>
  );
};

export default Loader;
